export enum SessionStorageKey {
    RecentSearches = 'AUTOCOMPLETE_RECENT_SEARCHES:RECENT_SEARCH',
    ErrorRetryCount = 'ERROR_RETRY_COUNT',
}
